import React from 'react';

import Layout from './Layout';
import MetaTags from '../shared/MetaTags';

const SubscriberDirectory = () => {
  const description =
    'Make connections worth your time without all the \
noise. Search, find and engage with others who are serious about tech and \
business.';

  return (
    <>
      <MetaTags
        title="The Information Subscriber Directory"
        description={description}
        ogImagePath="/images/directory/twitter_directory.png"
        ogSiteName="The Information"
      />
      <Layout />
    </>
  );
};

export default SubscriberDirectory;
